import CustomImageComponent from '@/components/shared/custom/custom-image';
import CustomLink from '@/components/shared/custom/custom-link';
import { REDUCERS } from '@/constants/reducers';
import { Rutas } from '@/constants/rutas';
import { Context } from '@/context';
import { obtenerEquipo } from '@/data/equipos';
import CustomTooltip from '@/DesignSystem/components/tooltip/CustomTooltip';
import { getMasterPhotoById, getTeamImageById } from '@/helpers/images-helper';
import { Box, Typography } from '@mui/material';
import { useContext } from 'react';

const NoticiaEntidadesRelacionadas = ({ noticia }) => {
    const { teams, players } = noticia;

    const { dispatch } = useContext(Context);

    const handleClickPlayer = (playerId) => {
        dispatch({ type: REDUCERS.SHOW_MASTER_ACCIONES_PLAYER_ID, payload: playerId });
    };

    if (!players?.length && !teams?.length) return null;

    return (
        <>
            <Typography variant="h6" mb={1}>
                Jugadores y equipos relacionados:
            </Typography>
            <Box display="flex" gap={1} overflow="auto">
                {players?.map((player) => (
                    <NoticiaEntidadRelacionada
                        key={player.id}
                        name={player.name}
                        image={getMasterPhotoById(player.id)}
                        style={{ borderRadius: '50%' }}
                        onClick={() => handleClickPlayer(player.id)}
                    />
                ))}
                {teams?.map((team) => {
                    const teamFound = obtenerEquipo(team.id);
                    return (
                        <CustomLink
                            href={`${Rutas.EQUIPO}/${teamFound.slug}`}
                            key={team.id}
                            disableLink={!teamFound}
                        >
                            <NoticiaEntidadRelacionada name={team.name} image={getTeamImageById(team.id)} />
                        </CustomLink>
                    );
                })}
            </Box>
        </>
    );
};

export default NoticiaEntidadesRelacionadas;

const NoticiaEntidadRelacionada = ({ name, image, style, onClick }) => {
    return (
        <CustomTooltip label={name}>
            <CustomImageComponent
                style={{ ...style }}
                src={image}
                alt={name}
                width={30}
                height={30}
                onClick={onClick ? () => onClick() : undefined}
            />
        </CustomTooltip>
    );
};
